import React, { Component } from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { tabulateImmutable } from "MODULES/shared/decorators";
import { repairOrderActions } from "MODULES/parts/actions";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { CompanyName, NoteTooltipTableCell } from "MODULES/shared/components";
import {
  AVG_OVERHAUL,
  AVG_REPAIR,
  AVG_TEST,
  AWAITING_REPLY,
  BER_RATE,
  EVALUATION_FEE,
  NO_CAPES,
  OVERHAUL_TAT,
  QUOTE_TYPES_ABBREV,
  REPAIR_TAT,
  TEST_TAT,
  TURNAROUND_TIME
} from "MODULES/RepairQuotes/constants";
import LineItemStatusCell from "MODULES/RepairQuotes/styles";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { percentFormatter } from "MODULES/shared/components/StatsTooltip/format";

const tatField = (lineItem, field) => lineItem[field] || "--";

const renderTat = lineItem =>
  [OVERHAUL_TAT, REPAIR_TAT, TEST_TAT]
    .map(f => tatField(lineItem, f))
    .join("/");

export const RenderQuoteField = ({
  lineItem,
  field,
  formatter = f => dollars(f, 0, true)
}) => {
  if ([NO_CAPES, AWAITING_REPLY].includes(lineItem.quote_type)) {
    return <th />;
  }

  if (field === TURNAROUND_TIME) {
    return <td className="text-right">{renderTat(lineItem)}</td>;
  }

  return <td className="text-right">{formatter(lineItem[field])}</td>;
};

RenderQuoteField.propTypes = {
  lineItem: PropTypes.instanceOf(Map),
  field: PropTypes.string,
  formatter: PropTypes.func
};

function renderRow(lineItemMap, i, select) {
  const lineItem = lineItemMap.toJS();
  return (
    <tr
      key={lineItem.id}
      className="clickable"
      onClick={() => select(lineItem)}
    >
      <td>{i + 1}</td>
      <LineItemStatusCell lineItem={lineItem}>
        {lineItem.code}
      </LineItemStatusCell>
      <td>
        <span
          className={
            lineItem.updated_at !== lineItem.created_at && "text-yellow"
          }
        >
          {shortDate(lineItem.updated_at || lineItem.created_at)}
        </span>
      </td>
      <td>{getFirstNameLastInitial(lineItem.created_by.full_name)}</td>
      <td>{QUOTE_TYPES_ABBREV[lineItem.quote_type]}</td>
      <td>
        <CompanyName
          flattenedCompany={lineItem}
          context="repair"
          truncateAt={25}
        />
      </td>
      <td>{lineItem.contact_name}</td>
      <RenderQuoteField lineItem={lineItem} field={AVG_OVERHAUL} />
      <RenderQuoteField lineItem={lineItem} field={AVG_REPAIR} />
      <RenderQuoteField lineItem={lineItem} field={AVG_TEST} />
      <RenderQuoteField lineItem={lineItem} field={TURNAROUND_TIME} />
      <RenderQuoteField lineItem={lineItem} field={EVALUATION_FEE} />
      <RenderQuoteField
        lineItem={lineItem}
        field={BER_RATE}
        formatter={f => percentFormatter(f)}
      />
      <NoteTooltipTableCell note={lineItem.notes} />
    </tr>
  );
}

export class Table extends Component {
  static propTypes = {
    openEditModal: PropTypes.func.isRequired,
    setPageSize: PropTypes.func.isRequired,
    results: PropTypes.instanceOf(List).isRequired,
    setLineItem: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.setPageSize(25);
  }

  render() {
    const { results, openEditModal, setLineItem } = this.props;

    const selectLineItem = lineItem => {
      setLineItem(lineItem);
      openEditModal(true);
    };

    return (
      <table className="table table-striped table-hover table-numbered">
        <thead>
          <tr>
            <th />
            <th>RQ #</th>
            <th>Date Created</th>
            <th>Created By</th>
            <th>Type</th>
            <th>Repair Station</th>
            <th>Contact</th>
            <th className="text-right">Avg OH</th>
            <th className="text-right">Avg SV</th>
            <th className="text-right">Avg BT</th>
            <th className="text-right">TAT</th>
            <th className="text-right">Eval Fee</th>
            <th className="text-right">BER (%)</th>
            <th />
          </tr>
        </thead>
        <tbody>{results.map((r, i) => renderRow(r, i, selectLineItem))}</tbody>
      </table>
    );
  }
}

export default connect(
  () => ({
    listId: "part/repairQuoteLineItems"
  }),
  {
    setPageSize: repairOrderActions.pageActions.setPageSize
  }
)(tabulateImmutable(Table));



// WEBPACK FOOTER //
// ./app/modules/parts/components/RepairQuoteLineItems/Table.jsx